export default __webpack_public_path__ + "static/media/icon-3.e0177805.svg";